import http from "../../HttpConfig";
import { APIS_ENDPOINTS } from "../../SERVICE-CONSTANTS";
const userProfileValidation_endpoints = APIS_ENDPOINTS.userProfileValidation


export const request_upsertUserProfileValidation = async (data: {
    id: number
    userProfileId: number
    email: boolean;
    emailComment: string;
    registrationNumber: boolean;
    registrationNumberComment: string;
    webSite: boolean;
    webSiteComment: string;
    economicCode: boolean;
    economicCodeComment: string;
    placeOfRegistration: boolean;
    placeOfRegistrationComment: string;
    provincePlaceOfRegistration: boolean;
    provincePlaceOfRegistrationComment: string;
    dateOfEstablishment: boolean;
    dateOfEstablishmentComment: string;
    initialInvestment: boolean;
    initialInvestmentComment: string;
    currentCapital: boolean;
    currentCapitalComment: string;
    subjectOfActivityBySelect: boolean;
    subjectOfActivityBySelectComment: string;
    subjectOfActivity: boolean;
    subjectOfActivityComment: string;
    maliatCode: boolean;
    maliatCodeComment: string;
    valueAdded: boolean;
    valueAddedComment: string;
    companyValidationFile: boolean;
    companyValidationFileComment: string;
    companyType: boolean;
    companyTypeComment: string;
    latestChangesInRegistration: boolean;
    latestChangesInRegistrationComment: string;
    companyResume: boolean;
    companyResumeComment: string;
    companyLicenses: boolean;
    companyLicensesComment: string;
    otherDocumnet: boolean;
    otherDocumnetComment: string;
    lastYearDeclaration: boolean;
    lastYearDeclarationComment: string;
    declarationTwoYearsAgo: boolean;
    declarationTwoYearsAgoComment: string;
    thisYearsFinancialStatements: boolean;
    thisYearsFinancialStatementsComment: string;
    auditReport: boolean;
    auditReportComment: string;
    companyAccountTurnover: boolean;
    companyAccountTurnoverComment: string;
    foundedAd: boolean;
    foundedAdComment: string;
    boardOfDirectors: boolean;
    boardOfDirectorsComment: string;
    companyPlaces: boolean;
    companyPlacesComment: string;
    legalShareholder: boolean;
    legalShareholderComment: string;
    isSendSms: boolean,
    technologyLicense: boolean;
    technologyLicenseComment: string;
    knowledgeBasedLicense: boolean;
    knowledgeBasedLicenseComment: string;
    creativeLicense: boolean;
    creativeLicenseComment: string;
    representativeName: boolean;
    representativeNameComment: string;
    representativePhone: boolean;
    representativePhoneComment: string;
}) => {
    return http.post(userProfileValidation_endpoints.upsert, data);
};


export const request_getforuser = async (UserProfileId: number) => {
    return http.get(
        userProfileValidation_endpoints.getToEdit + '?UserProfileId=' + UserProfileId
    )
}